export default "__VITE_PUBLIC_ASSET__21f36436__"